import "./Avatar.scss";

export default function Avatar({ style }) {
  return (
    <>
      <div className="avatar__container" style={style}></div>
    </>
  );
}
